<div class="menu">
  <div class="menu-header">
    <form
      class="search-container"
      (ngSubmit)="search()"
    >
      <input
        class="search"
        type="text"
        name="searchText"
        [(ngModel)]="searchText"
        [placeholder]="'generalsearch' | translate"
      >
      <button class="search-btn"></button>
    </form>
  </div>
  <div class="menu-content">
    <div
      *ngFor="let section of menuData"
      class="menu-section"
    >
      <div class="menu-section-title">{{ section.title }}</div>
      <div class="menu-section-spacer"></div>
      <div class="menu-section-content">
        <ul class="menu-items">
          <li
            *ngFor="let item of section.items"
            class="menu-item"
          >
            <a
              [href]="item.url"
              class="link menu-item-link"
            >{{ item.label }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="menu-footer">
    <a
      class="link"
      [href]="menuSettingUrl"
    >{{ 'generalmenusettings' | translate }}</a>
  </div>
</div>
